import { render, staticRenderFns } from "./InformacaoValor.vue?vue&type=template&id=5a78d00c&scoped=true&"
import script from "./InformacaoValor.vue?vue&type=script&lang=js&"
export * from "./InformacaoValor.vue?vue&type=script&lang=js&"
import style0 from "./InformacaoValor.vue?vue&type=style&index=0&id=5a78d00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a78d00c",
  null
  
)

export default component.exports